import type { GraphemeGlyph } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";

export const GRID_GAP_DEFAULT = 6;
export const MORPHEME_GLYPH_TILE_GRID_COLUMNS = 8;

/** A bare grapheme string becomes a default-styled glyph; a styled glyph passes through. */
export function normalizeGraphemeGlyph(entry: string | GraphemeGlyph): GraphemeGlyph {
  return typeof entry === "string"
    ? { color: null, display: entry, fontWeight: "400", original: entry }
    : entry;
}
